module.exports = __webpack_public_path__ + "static/img/1.96868fe3.png";